import type { HdcReport } from "../../../../../ExperianPrivateResponse.types";
import { GlobalRowVM, mapGlobalIndebtedness } from "../mappers";
import { C } from "../theme";
import { Card } from "../shared/Card";
import { Column, DataTable } from "../shared/DataTable";

const columns: Column<GlobalRowVM>[] = [
  { key: "entity", header: "Entidad", align: "l", strong: true, render: (g) => g.entity },
  { key: "sector", header: "Sector", render: (g) => g.sector },
  {
    key: "rating",
    header: "Calif. trimestre",
    render: (g) => g.rating,
    cellStyle: () => ({ fontWeight: 700 }),
  },
  { key: "credit", header: "Tipo de crédito", render: (g) => g.credit },
  { key: "count", header: "Obligaciones", render: (g) => g.count },
  {
    key: "capital",
    header: "Valor capital",
    align: "r",
    render: (g) => g.capital,
    cellStyle: () => ({ color: C.white }),
  },
  { key: "guarantee", header: "Garantía", align: "l", render: (g) => g.guarantee },
  { key: "guaranteeValue", header: "Valor garantía", align: "r", render: (g) => g.guaranteeValue },
];

export const EndeudamientoGlobalTab = ({ report }: { report: HdcReport }) => {
  const g = mapGlobalIndebtedness(report);
  return (
    <Card
      flush
      title="Endeudamiento global"
      aside={`Fuente: ${g.source} · corte ${g.cutoff}`}
    >
      <DataTable caption="Endeudamiento global" columns={columns} rows={g.rows} />
    </Card>
  );
};
